import cx from 'clsx';
import type { CardProps } from 'src/components/core';
import { Card, Stack, TextLink, Type } from 'src/components/core';
import { Avatar } from 'src/components/user/avatar.component';

export interface DocumentAuthorCardProps
  extends Partial<Omit<CardProps, 'ref'>> {
  className?: string;
  author: {
    title: string;
    content: string;
    publishedAt: string;
    slug: string;
    author: string;
    image: { data?: { attributes: { url: string } } };
    author_image: { data?: { attributes: { url: string } } };
    short_description?: string;
  };
}

export function DocumentAuthorCard({
  className,
  author,
  style = {},
  ...rest
}: DocumentAuthorCardProps) {
  return (
    <Card
      className={cx('pt-0 border-t-8', className)}
      style={{
        borderTopColor: '#27396e',
        ...style,
      }}
      {...rest}
    >
      <Stack alignItems="items-start">
        <Avatar className="shrink-0" user={author} />
        <div>
          <Type bold variant="text-lg">
            {author?.author}
          </Type>
          <Type colorVariant="faded" variant="text-sm">
            {/* {author.title} */}
            Founder at The Population Project
          </Type>
          <TextLink
            className="text-sm"
            href={`mailto:antoine@thepopulationproject.org`}
          >
            {/* {author.email} */}
            antoine@thepopulationproject.org
          </TextLink>
        </div>
      </Stack>
    </Card>
  );
}
